var React = require('react');

function Delete (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7,14a6.867,6.867,0,0,1-2.721-.554A6.849,6.849,0,0,1,.554,9.721a6.96,6.96,0,0,1,0-5.441A6.849,6.849,0,0,1,4.279.554a6.96,6.96,0,0,1,5.441,0,6.849,6.849,0,0,1,3.726,3.726,6.96,6.96,0,0,1,0,5.441,6.849,6.849,0,0,1-3.726,3.726A6.867,6.867,0,0,1,7,14Zm3.227-8.955A.851.851,0,0,0,10.5,4.4a.911.911,0,0,0-.916-.916.852.852,0,0,0-.642.273L6.986,5.7,5.045,3.76A.851.851,0,0,0,4.4,3.486a.911.911,0,0,0-.916.916.852.852,0,0,0,.273.642L5.7,7,3.76,8.941a.851.851,0,0,0-.273.642A.912.912,0,0,0,4.4,10.5a.85.85,0,0,0,.642-.273L6.986,8.285l1.955,1.941a.851.851,0,0,0,.642.273.912.912,0,0,0,.917-.916.85.85,0,0,0-.273-.642L8.285,7Z","fill":"#cb0808"}));
}

Delete.defaultProps = {"viewBox":"0 0 14 14"};

module.exports = Delete;

Delete.default = Delete;
